export const prependHash = (step: string): string => `#${step}`
